module.exports = __webpack_public_path__ + "assets/86e41e1dc3865c5d809fdcb5de84b03b.svg";